import axios from 'axios'

export const getAllClients = (params) => {
  return axios.get('clients', {params: params})
}

export const getClient = (configs) => {
  let remoteUrl = 'clients/' + configs.id

  return axios.get(remoteUrl, {params: configs.params})
}

export const getTotalMoney = (configs) => {
  let remoteUrl = 'clients/statistic-info'

  return axios.get(remoteUrl, {params: configs.params})
}

export const updateClient = (data, configs = {}) => {
  let remoteUrl = 'clients/' + data.id

  return axios.put(remoteUrl, data, {params: configs.params})
}

export const deleteClient = (data, configs = {}) => {
  let remoteUrl = 'clients/' + data.id

  return axios.delete(remoteUrl, data, {params: configs.params})
}

export const exportExcel = (configs) => {
  let remoteUrl = 'payment/history/export-excel'

  return axios.get(remoteUrl, {params: configs.params})
}



// WEBPACK FOOTER //
// ./src/api/clients.js